import { render, staticRenderFns } from "./BoardGsku.vue?vue&type=template&id=5246078e&scoped=true&"
import script from "./BoardGsku.vue?vue&type=script&lang=js&"
export * from "./BoardGsku.vue?vue&type=script&lang=js&"
import style0 from "./BoardGsku.vue?vue&type=style&index=0&id=5246078e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5246078e",
  null
  
)

export default component.exports